<template>
	<b-card>
		<div slot="header" class="d-flex justify-content-between custom-card-header">
			<span class="card-header-title"> {{ $t('sidebar.warehouse-management.requests') }}</span>
			<div class="card-header-actions">
				<div class="searchInCard">
					<b-input-group size="sm">
						<b-form-input v-model="payload.keyword" size="sm" :placeholder="$t('contragent.filter')"
									  autocomplete="off" @input="getList"/>
						<b-input-group-append>
							<b-button :disabled="!payload.keyword" @click="getList(payload.keyword = '')">
								{{ $t('contragent.clear') }}
							</b-button>
						</b-input-group-append>
					</b-input-group>
				</div>
				<div class="card-header-actions">
					<b-link @click="createModal = true" class="card-header-action btn-setting"
							style="font-size: 20px">
						<i class="fa fa-plus-circle"></i>
					</b-link>
				</div>
			</div>
		</div>
		<table class="table table-hover table-bordered table-striped mt-3">
			<thead>
			<tr>
				<th class="text-center">№</th>
				<th class="text-center">{{ $t('incomes.name') }}</th>
				<th class="text-center">{{ $t('pricing.date') }}</th>
				<th class="text-center">{{ $t('incomes.fromDepartment') }}</th>
				<th class="text-center">{{ $t('incomes.toDepartment') }}</th>
				<th class="text-center">{{ $t('contragent.category-name') }}</th>
				<th class="text-center">{{ $t('sale.status') }}</th>
				<th class="text-center" style="width: 8%">{{ $t('actions.title') }}</th>
			</tr>
			</thead>
			<tbody>
			<template v-if="items.items.length">
				<tr v-for="(item, index) in items.items" :key="`item-${index}`">
					<td class="text-center">{{ paginate(index, payload.page, payload.limit) }}</td>
					<td class="text-center">{{ item.regNumber }}</td>
					<td class="text-center">{{ item.regDate }}</td>
					<td class="text-center">{{ item.fromDepartmentName }}</td>
					<td class="text-center">
						<b-badge v-for="dep in item.toDepartmentNames" class="mr-1">
							{{ dep }}
						</b-badge>
					</td>
					<td class="text-center">
						{{ item.subCategoryName }} /
						{{ item.sub2CategoryName }} /
						{{ item.sub3CategoryName }}
					</td>
					<td class="text-center">{{ item.status }}</td>
					<td class="text-center">
						<i v-if="item.status == 'SUSPENDED'" @click="editDoc(item.id)" style="cursor: pointer"
						   class="ml-2 fa fa-edit text-primary"></i>
						<i v-if="item.status == 'CHECKING' || item.status == 'READY'" @click="viewDoc(item.id)" style="cursor: pointer"
						   class="ml-2 fa fa-eye text-primary"></i>
						<i v-if="item.status == 'CHECKED'" @click="checkDoc(item.id)" style="cursor: pointer"
						   class="ml-2 fa fa-check text-success"></i>
						<i v-if="item.status != 'READY'" @click="deleteDoc(item.id)" style="cursor: pointer"
						   class="ml-2 fa fa-trash text-danger"></i>
					</td>
				</tr>
			</template>
			<tr v-else>
				<td colspan="8" class="text-center">
					<h5><b>Информация не найдена !</b></h5>
				</td>
			</tr>
			</tbody>
		</table>
		<nav>
			<b-pagination
				:total-rows="items.total"
				:per-page="payload.limit"
				v-model="payload.page"
				aria-controls="table"/>
		</nav>
		<b-modal
			v-model="createModal"
			:title="$t('incomes.create.create-request')"
			centered
		>
			<b-form-group
				breakpoint="lg"
				label-cols="3"
				label-for="refName"
				class="required ml-1"
			>
				<template slot="label">
					{{ $t('incomes.create.from-warehouse') }}
					<span class="text-danger">*</span>
				</template>
				<multiselect
					v-model="departmentId"
					:options="fromDepartments"
					:label="`name`"
					track-by="id"
					@select="selectedDep"
					:show-labels="false"
					:allow-empty="true"
					:placeholder="$t('promo-to-product.department')"
					class="multiselect-pricing h"
				></multiselect>
			</b-form-group>
			<b-form-group
				breakpoint="lg"
				label-cols="3"
				label-for="refName"
				class="required ml-1"
			>
				<template slot="label">
					{{ $t('incomes.create.to-warehouse') }} <span class="text-danger">*</span>
				</template>
				<multiselect
					v-model="toDepartmentId"
					:options="toDepartments"
					:multiple="true"
					:label="`name`"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					:placeholder="$t('promo-to-product.department')"
					class="multiselect-pricing h"
					:close-on-select="false"
					:clear-on-select="false"
				></multiselect>
			</b-form-group>
			<b-form-group
				breakpoint="lg"
				label-cols="3"
				label-for="refName"
				class="required ml-1"
			>
				<template slot="label">
					{{ $t('goods.create.select-group') }}
				</template>
				<multiselect
					v-model="subCategoryId"
					:options="subCategory_s"
					:label="`name`"
					track-by="id"
					@select="selectedSubGroup"
					:show-labels="false"
					:allow-empty="true"
					:placeholder="$t('goods.create.select-group')"
					class="multiselect-pricing h"
				></multiselect>
			</b-form-group>
			<b-form-group
				breakpoint="lg"
				label-cols="3"
				label-for="refName"
				class="required ml-1"
			>
				<template slot="label">
					{{ $t('goods.create.category') }}
				</template>
				<multiselect
					v-model="subCategory1Id"
					:options="subCategory1_s"
					:disabled="!subCategoryId"
					:label="`name`"
					track-by="id"
					@select="selectedSubCategory"
					:show-labels="false"
					:allow-empty="true"
					:placeholder="$t('goods.create.category')"
					class="multiselect-pricing h"
				></multiselect>
			</b-form-group>
			<b-form-group
				breakpoint="lg"
				label-cols="3"
				label-for="refName"
				class="required ml-1"
			>
				<template slot="label">
					{{ $t('goods.create.select-subcategory') }}
				</template>
				<multiselect
					v-model="subCategory2Id"
					:options="subCategory2_s"
					:disabled="!subCategory1Id"
					:label="`name`"
					track-by="id"
					@select="subcategory"
					:show-labels="false"
					:allow-empty="true"
					:placeholder="$t('goods.create.select-subcategory')"
					class="multiselect-pricing h"
				></multiselect>
			</b-form-group>
			<template #modal-footer>
				<b-button size="sm" variant="danger" @click="createModal = false">{{ $t('actions.cancel') }}</b-button>
				<b-button size="sm" variant="success" @click="createRequest">
					{{ $t('sidebar.warehouse-management.request') }}
					<b-spinner v-if="spinner" small></b-spinner>
				</b-button>
			</template>
		</b-modal>
	</b-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import UsersService from "../../../services/users.sevice";
import ReferencesService from "../../../services/references.sevice";
import WhDocument from "../../../services/wh-document.service";

export default {
	name: "index",
	components: {Multiselect},
	data() {
		return {
			createModal: false,
			spinner: false,
			selectedDepIds: [],
			departmentId: null,
			toDepartmentId: [],
			fromDepartments: '',
			toDepartments: '',
			subCategory_s: [],
			subCategoryId: null,
			subCategory1_s: [],
			subCategory1Id: null,
			subCategory2_s: [],
			subCategory2Id: null,
			items: [],
			payload: {
				page: 1,
				limit: 20,
				keyword: '',
			},
			data: {
				subCategoryId: null,
				sub2CategoryId: null,
				sub3CategoryId: null,
				fromDepartmentId: null,
				toDepartmentIds: []
			}
		}
	},
	methods: {
		selectedDep(selectedOption) {
			this.data.fromDepartmentId = selectedOption.id
			this.toDepartments.forEach(d => {
				if (d.$isDisabled) {
					d.$isDisabled = false
				}
			})
			this.toDepartments.forEach(d => {
				if (selectedOption.id == d.id) {
					d.$isDisabled = true
				}
			})
		},
		async selectedSubGroup($event) {
			this.subCategory1Id = null
			this.subCategory2Id = null
			this.data.subCategoryId = $event.id
			await ReferencesService.getSubReferenceChildren($event.id).then(res => {
				this.subCategory1_s = res.data
			})
		},
		async selectedSubCategory($event) {
			this.subCategory2Id = null
			this.data.sub2CategoryId = $event.id
			await ReferencesService.getSubReferenceChildren($event.id).then(res => {
				this.subCategory2_s = res.data
			})
		},
		subcategory($event) {
			this.data.sub3CategoryId = $event.id
		},
		createRequest() {
			this.spinner = true
			if (this.data.fromDepartmentId != null && this.data.toDepartmentIds.length > 0) {
				WhDocument.createRequestDoc(this.data).then(res => {
					this.$router.push(`/request-warehouse/create_or_edit/${res.data.id}/edit`)
					this.$vs.notify({
						title: 'Success',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					})
				}).catch(e => {
					this.$vs.notify({
						title: this.$t('words.error'),
						text: e,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				})
			} else {
				this.$vs.notify({
					title: this.$t('words.error'),
					text: this.$t('words.validation-error'),
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			}
			this.spinner = false
		},
		deleteDoc(id) {
			this.$bvModal.msgBoxConfirm(this.$t('actions.deletetitle'), {
				hideHeader: true,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'danger',
				okTitle: this.$t('actions.yes'),
				cancelTitle: this.$t('actions.no'),
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value) {
					WhDocument.deleteRequestDoc(id).then(res => {
						this.getList();
						this.$vs.notify({
							title: 'Success',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						})
					}).catch(e => {
						this.$vs.notify({
							title: this.$t('words.error'),
							text: e,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					})
				}
			})
		},
		editDoc(id) {
			this.$router.push(`/request-warehouse/create_or_edit/${id}/edit`)
		},
		viewDoc(id) {
			this.$router.push(`/request-warehouse/create_or_edit/${id}/view`)
		},
		checkDoc(id) {
			this.$router.push(`/request-warehouse/create_or_edit/${id}/check`)
		},
		async getList() {
			await WhDocument.getRequestDocs(this.payload).then(res => {
				this.items = res.data
			})
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		}
	},
	watch: {
		toDepartmentId: {
			handler(v) {
				this.data.toDepartmentIds = v.map(e => e.id)
			}
		},
		'payload.page': {
			async handler(newVal) {
				await this.getList();
			}
		}
	},
	created() {
		UsersService.getPermittedDepartments().then(res => {
			this.fromDepartments = res.data.permittedDepartments
			this.toDepartments = res.data.transferPermittedDepartments
		})
		ReferencesService.getSubReferenceChildren(14).then(res => {
			this.subCategory_s = res.data
		})
		this.getList();
	}
}
</script>

<style scoped>

</style>
